import React from 'react';
import { useViewTracker } from '../providers/ViewTrackerProvider';

interface Props {
    source: string;
    sourceId?: string;
    sourceDetail?: string;
    children: React.ReactNode;
}

export const ViewTracker: React.FC<Props> = ({
    source,
    sourceId,
    sourceDetail,
    children,
}: Props) => {
    const { setSource, setSourceId, setSourceDetail } = useViewTracker();

    return (
        <span
            onClick={() => {
                setSource(source);
                setSourceId(sourceId);
                setSourceDetail(sourceDetail);
            }}
        >
            {children}
        </span>
    );
};
